import Helper from './Helper';

class ListTable {
  constructor() {

    this.tables = document.querySelectorAll('.ns-table-wrap table');
    this.tablesCells = document.querySelectorAll('.ns-table-wrap table td');

    if (this.tables) {
      this.bindEvents();
    }
  }

  bindEvents(){
   this.tablesCells.forEach(content => {
    this.bindReplaceList(content);
   });
  }

  bindReplaceList(content){

    let idxList = content.innerHTML.search('{{list}}');
    let idxSpan = content.innerHTML.search('</span></p>');

      if(idxList != -1){

        content.innerHTML =
          content.innerHTML.slice(0,idxList-1) +
          "</span><span class='list__mtop'>" +
          content.innerHTML.slice(idxList+8, idxSpan) +
          content.innerHTML.slice(idxSpan, -1);

        if(content.innerHTML.search('{{list}}') != -1){
          this.bindReplaceList(content);
        }
      }
  }

}

export default ListTable;
